export default __webpack_public_path__ + "images/metamask_45038d.svg";